import { css } from "lit";
//#region src/styles/shared-input-field-styles.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Shared styles for pd-input, pd-input-area and pd-select.
*/
var SharedInputFieldStyles = css`
  /* Describe input div (with icon) around input/select/area element */
  .input {
    display: inline-block;
    width: var(--pd-input-field-width, 250px);
    /*position: relative; Prüfen: Wenn das an ist, felder über scroll-menu?
    position: relative;
    */
    /* pd-icon smaller than input
    --pd-icon-computed-size: calc(var(--my-input-height) * 0.75); /* calc */

    /* Hack um eine Form Row (input mit Button => Booking) zu bekommen*/
    /*padding-top: var(--squi-input-padding, 0.5rem); */
  }

  :host([text-right]) .input > input {
    text-align: right;
  }
  :host([text-left]) .input > input {
    text-align: left;
  }

  :host([icon-left]) .input pd-icon {
    display: inline-block;
    left: 5px;
  }

  :host([icon-left]) .input > input {
    padding-left: calc(var(--pd-input-field-height, 2rem) + 5px);
  }

  :host([icon-right]) .input pd-icon {
    display: inline-block;
    right: 5px;
  }

  :host([icon-right]) .input > input {
    padding-right: calc(var(--pd-input-field-height, 2rem) + 5px);
  }

  /* relative hack => see comment above in .input class, do it only for icon fiels relative for the moment*/
  :host([icon-right]) .input {
    position: relative;
  }
  :host([icon-left]) .input {
    position: relative;
  }

  .infield-icon {
    display: none;
    position: absolute;
    --pd-icon-size: var(
      --pd-input-icon-size,
      calc(var(--pd-input-field-height, 2rem) * 0.9)
    );
    --pd-icon-col-active: var(--pd-input-icon-color, var(--pd-default-col));
    top: 50%;
    transform: translateY(-50%);
  }

  /*
   * Fokusring im Hausstil statt des Browser-Defaults (vgl. pd-button).
   * Nur :focus-visible, damit ein Mausklick keinen Ring hinterlässt.
   * outline-offset hier 0 statt der sonst üblichen 2px: Das Icon sitzt
   * INNERHALB des Feldes und füllt es fast aus — ein abgesetzter Ring
   * ragte über den Feldrahmen hinaus.
   */
  .infield-icon:focus-visible {
    outline: 2px solid var(--pd-focus-ring-col, currentColor);
    outline-offset: 0;
    border-radius: var(--pd-radius-sm, 2px);
  }

  /*
   * Class input style used for input, select and text-area element.
   * Not use iput here => because of own select css... => Nachtrag: Aber ein paar allgemeine Angaben rausziehen
   */
  .input-style {
    width: var(--pd-input-field-width, 250px);
    box-sizing: border-box;
    padding: var(--pd-input-field-padding, 0.25rem);
    background-color: var(--pd-input-field-bg-col, var(--pd-default-bg-col));
    /*opacity: 80%;*/
    color: var(--pd-default-font-input-col);
    /*font-size: var(--squi-input-font-size, calc(var(--squi-input-height) / 1.8));*/
    font-size: var(--pd-default-font-input-size);
    font-family: var(--pd-default-font-input-family);

    border: var(--pd-input-field-border, 1px solid var(--pd-default-light-col));
    box-shadow: inset 0 1px 2px rgba(50, 48, 49, 0.1);
    border-bottom: var(
      --pd-input-field-border-bottom,
      2px solid var(--pd-default-col)
    );
    border-radius: var(--pd-radius-md);
    outline: none;
  }

  /* Hover for input, area, select */
  .input-style:hover {
    border-color: var(
      --pd-input-field-border-col-hover,
      var(--pd-default-hover-col)
    );
  }

  /* Höhe soll nicht für Text Area gelten, daher ausgelagert (überschreibt sonst rows) */
  input.input-style,
  select.input-style {
    height: var(--pd-input-field-height, 2.5rem);
  }

  /* Disabled for input, area => select with own css.? */
  .input-style[disabled] {
    opacity: 0.5;
    cursor: auto;
    background-color: var(--pd-input-field-bg-col-disabled, #e9e9e9);
    border-bottom: var(
      --pd-input-field-border-bottom-disabled,
      2px solid var(--pd-default-disabled-col)
    );
  }

  .input-style[readonly]:hover,
  .input-style[disabled]:hover {
    border-color: var(--pd-default-disabled-col);
  }

  /* Disabled for input, area => select with own css.? */
  .input-style[readonly] {
    border-bottom: var(
      --pd-input-field-border-bottom-disabled,
      2px solid var(--pd-default-disabled-col)
    );
  }

  /* Fokus for input, area => select with own css.? */
  .focus .input-style {
    border: var(--pd-input-field-border-focus, 2px solid var(--pd-default-col));
    outline: 0;
  }

  /* error element style for input, area => select has own css.? */
  .error .input-style {
    border: 1px solid var(--pd-default-error-col);
    color: var(--pd-default-error-col);
    background-color: var(--pd-default-error-light-col);
  }

  /* Error Focus for input, area, select */
  .focus.error .input-style {
    border: 2px solid var(--pd-default-error-col);
  }

  /*
   * Valid element style for input, area => select has own css.?
   *
   * Eigene Tokens statt der globalen Erfolgsfarbe: Eine App, der die grüne
   * Quittung am Feld zu laut ist (oder die nicht in ihre Palette passt), kann
   * sie hier abschalten, ohne --pd-default-success-col umzudefinieren — die
   * trägt auch Erfolgsmeldungen in Toasts und Hinweisboxen.
   */
  .valid .input-style {
    border: 1px solid
      var(--pd-input-field-border-valid-col, var(--pd-default-success-col));
    background-color: var(
      --pd-input-field-bg-col-valid,
      var(--pd-default-success-light-col)
    );
  }

  /* Valid Focus for input, area, select */
  .focus.valid .input-style {
    border: 2px solid
      var(--pd-input-field-border-valid-col, var(--pd-default-success-col));
  }

  /* Placeholder color for input and input-area */
  ::placeholder {
    color: var(--pd-default-font-muted-col);
  }
  :-ms-input-placeholder {
    color: var(--pd-default-font-muted-col);
  }
  ::-ms-input-placeholder {
    color: var(--pd-default-font-muted-col);
  }
`;
//#endregion
export { SharedInputFieldStyles };
